import WidgetsMgr from 'widgets/widgetsMgr';

WidgetsMgr.addWidgetsList('global.core', () => []);
